module.exports = __webpack_public_path__ + "img/wqq-index.cae118d9.jpg";